import AddDataSourcePage from './addNewDataSource.page';

export default AddDataSourcePage;
